"use client"

import { Check, Copy01 } from "@untitledui/icons"
import { useState } from "react"

import { Button } from "@/components/ui/button"

// Copies a warm start's shareable magic link to the clipboard. Icon-only in the
// ledger table's action column; `withLabel` adds text for the ready-link card.
export function CopyLinkButton({
  url,
  withLabel,
}: {
  url: string
  withLabel?: boolean
}) {
  const [copied, setCopied] = useState(false)

  const copy = () => {
    void navigator.clipboard.writeText(url).then(() => {
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    })
  }

  return (
    <Button
      color="secondary"
      size="sm"
      iconLeading={copied ? Check : Copy01}
      onClick={copy}
      aria-label={copied ? "Copied" : "Copy link"}
    >
      {withLabel ? (copied ? "Copied" : "Copy link") : undefined}
    </Button>
  )
}
